import { render, staticRenderFns } from "./UserTableCrud.vue?vue&type=template&id=569cbc1f&"
import script from "./UserTableCrud.vue?vue&type=script&lang=js&"
export * from "./UserTableCrud.vue?vue&type=script&lang=js&"
import style0 from "./UserTableCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports